import * as React from 'react';
import {connect} from 'react-redux';
import {
    createBusinessObject,
    deleteBusinessObject,
    updateBusinessObject,
    updateBOUniqueNameAttribute
} from '../../../actions/boCoreActions';
import * as toastr from "toastr";
import {DataTypesEnum} from "../enums/dataTypesEnum";
import {BusinessObject} from "../models/BusinessObject";
import {numberComparator, stringComparator} from "../common/slickGridComparators";
import BusinessObjects from "../../../views/bo-core/BusinessObjects";
import {EVENTS} from "../../../config/boCore";
import Utils from "../../../Utils";
import {setBusinessObject} from "../../../actions/manageDataBusinessObjectActions";


interface Props {
    currentBusinessObject: any;
    businessObjectsWrapper: any;

    deleteBusinessObject(id: number, arg: any): any;

    createBusinessObject(dto: any, arg: any, uniqueNameObj?: any): void;

    updateBusinessObject(dto: any, arg: any, uniqueNameObj?: any): void;

    updateBOUniqueNameAttribute(id: number, isUnique: boolean, args: object): void;

    setBusinessObject(object: any): void;
}

interface State {
    rowId: number;
}

declare const Slick: any;
const lastEditableCol = 4, firstEditableCol = 1;

class BusinessObjectTypesGrid extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            rowId: 0
        }
    }

    UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.boView.typesGrid.open)
            .unbind(EVENTS.boView.typesGrid.create)
            .unbind(EVENTS.boView.typesGrid.update)
            .unbind(EVENTS.boView.typesGrid.delete)
            .on(EVENTS.boView.typesGrid.open, (event: any) => {
                this.buildGrid(event.args.data, event.args.bocId);
                event.preventDefault();
            })
            .on(EVENTS.boView.typesGrid.create, (event: any) => {
                const grid = $("#BusinessObjectTypesGrid").data("gridInstance");
                const dataView = grid.getData();
                const businessObjectsWrapper = event.args.data;
                const businessObject = businessObjectsWrapper.getBusinessObject(event.args.id);
                dataView.beginUpdate();
                dataView.deleteItem(-1);
                dataView.insertItem(0, businessObject.clone());
                dataView.endUpdate();
                if (event.args.withNewRow) {
                    addNewRow(dataView);
                    setTimeout(() => {
                        grid.setSelectedRows([0]);
                        grid.setActiveCell(0, 1);
                    }, 1);
                } else {
                    const row = dataView.getRowById(event.args.id);
                    setTimeout(() => {
                        grid.setSelectedRows([row]);
                        BusinessObject.enableButton("types-new-btn");
                    }, 1);
                }
                event.preventDefault();
            })
            .on(EVENTS.boView.typesGrid.update, (event: any, {currentBusinessObject} = this.props) => {
                const grid = $("#BusinessObjectTypesGrid").data("gridInstance");
                const businessObject = event.args.businessObject;
                currentBusinessObject.name = businessObject.name;
                currentBusinessObject.description = businessObject.description;
                currentBusinessObject.systemRequired = businessObject.systemRequired;
                currentBusinessObject.uniqueName = businessObject.uniqueName;
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows(grid.getSelectedRows());
                }, 1)
            })
            .on(EVENTS.boView.typesGrid.delete, (event: any) => {
                const grid = $("#BusinessObjectTypesGrid").data("gridInstance");
                const dataView = grid.getData();
                const row = dataView.getRowById(event.args.id);
                dataView.beginUpdate();
                dataView.deleteItem(event.args.id);
                dataView.endUpdate();
                grid.invalidateRow(row);
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows([row]);
                    grid.render();
                }, 1);
            })
    }

    buildGrid = (businessObjectsWrapper, bocId) => {
        let grid, dataView;
        const data = businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY).map(item => item.clone()).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        let radioSelector = new Slick.RadioSelectColumn({
            cssClass: "slick-cell-checkboxsel",
            columnId: "type-grid-checkbox"
        });

        let columnFilters = {};
        const columns = [
            radioSelector.getColumnDefinition(),
            {
                id: "name",
                name: "Type Name",
                field: "name",
                width: 80,
                minWidth: 50,
                editor: TextEditor,
                sortable: true
            },
            {
                id: "description",
                name: "Description",
                field: "description",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "instancesCount",
                name: "Instances Count",
                field: "instancesCount",
                width: 40,
                minWidth: 40,
                sortable: true
            },
            {
                id: "uniqueName",
                name: "Unique Name",
                field: "uniqueName",
                width: 90,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            },
            {
                id: "systemRequired",
                name: "System Required",
                field: "systemRequired",
                width: 90,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            }
        ];

        const options = {
            enableCellNavigation: true,
            enableColumnReorder: false,
            forceFitColumns: true,
            multiColumnSort: false,
            editable: true,
            showHeaderRow: true,
            headerRowHeight: 30,
            explicitInitialization: true
        };

        function filter(item) {
            const keys = Object.keys(columnFilters);
            for (let i = 0; i < keys.length; i++) {
                if (columnFilters[keys[i]] !== "") {
                    const c = grid.getColumns()[grid.getColumnIndex(keys[i])];
                    if (!item[c.field].toString().toLowerCase().includes(columnFilters[keys[i]].toString().toLowerCase())) {
                        return false;
                    }
                }
            }
            return true;
        }

        const getCurrentBusinessObject = () => {
            return this.props.currentBusinessObject;
        };
        const getBusinessObjectWrapper = () => {
            return this.props.businessObjectsWrapper;
        };

        function SwitchEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = $("<input id='toggle-one' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-size='mini'/>");
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.prop('checked', args.item[args.column.field]);

                $input.bootstrapToggle({
                    on: 'true',
                    off: 'false'
                });

                $input.change(function () {
                    const currentBusinessObject = getCurrentBusinessObject();
                    const currentBusinessObjectsWrapper = getBusinessObjectWrapper();
                    const originalBusinessObject = currentBusinessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                    if (args.column.id === 'systemRequired') {
                        if (originalBusinessObject && originalBusinessObject.systemRequired && !$input[0].checked) {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'Unlocking this Business object class may cause problem with some functionalities. Are you sure you want to continue?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            setSwitchValue('systemRequired');
                                            saveBoClass(false);
                                        }
                                    },
                                    cancel: function () {
                                        $input.bootstrapToggle("toggle")
                                    }
                                }
                            });
                        } else {
                            setSwitchValue('systemRequired')
                        }
                    } else if (args.column.id === 'uniqueName') {
                        setSwitchValue('uniqueName');
                    }

                    function setSwitchValue(attribute: string) {
                        currentBusinessObject[attribute] = $input[0].checked;
                        const result = currentBusinessObjectsWrapper.checkBusinessObjectsBeforeSave(currentBusinessObject);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#types-save-btn"));
                        if (!result.valid) {
                            BusinessObject.disableButton("types-save-btn");
                            return;
                        }
                        BusinessObject.enableButton("types-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                /**
                 * @namespace this.isValueChanged
                 * @return {boolean}
                 */
                this.isValueChanged = function () {
                    return args.item.input !== $input.val()
                };
                /**
                 * @namespace this.loadValue
                 * @param item
                 */
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field];
                    $input.val(defaultValue);
                    $input.select();
                };
                /**
                 * @namespace  this.serializeValue
                 * @return {{input: (*|jQuery|*|*|*|*)}}
                 */
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                /**
                 * @namespace this.applyValue
                 * @param item
                 */
                this.applyValue = function (item) {
                    item[args.column.field] = $input[0].checked;
                };
                /**
                 * @namespace this.validate
                 * @return {{valid: boolean, msg: null}}
                 */
                this.validate = function () {
                    return {valid: true, msg: null}
                };
            };
            this.init();
        }

        function TextEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = $(`<input type=text class='editor-text rounded' />`);
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.keyup(function (e) {
                    const currentBusinessObjectsWrapper = getBusinessObjectWrapper();
                    const currentBusinessObject = getCurrentBusinessObject();
                    switch (args.column.id) {
                        case "name": {
                            currentBusinessObject.name = e.target.value;
                        }
                            break;
                        case "description": {
                            currentBusinessObject.description = e.target.value;
                        }
                    }
                    const result = currentBusinessObjectsWrapper.checkBusinessObjectsBeforeSave(currentBusinessObject);
                    BusinessObjects.appendQtipsToNode(result.data, grid, $("#types-save-btn"));
                    if (!result.valid) {
                        BusinessObject.disableButton("types-save-btn");
                        return;
                    }
                    BusinessObject.enableButton("types-save-btn", "");
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                /**
                 * @return {boolean}
                 * @namespace this.isValueChanged
                 */
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                /**
                 * @param item
                 * @namespace this.loadValue
                 */
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field] || "";

                    $input.val(defaultValue);
                    $input[0].defaultValue = defaultValue;
                    $input.select();
                };
                /**
                 * @return {{input: (*|jQuery|*|*|*|*)}}
                 * @namespace this.serializeValue
                 */
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                /**
                 * @param item
                 * @param state
                 * @namespace this.applyValue
                 */
                this.applyValue = function (item, state) {
                    item[args.column.field] = state.input;
                };
                /**
                 * @return {{valid: boolean, msg: string}}
                 * @namespace  this.validate
                 */
                this.validate = function () {
                    const currentBusinessObjectsWrapper = getBusinessObjectWrapper();
                    const currentBusinessObject = getCurrentBusinessObject();
                    switch (args.column.id) {
                        case "name": {
                            if (currentBusinessObjectsWrapper.hasBusinessObjectByNameExceptId(currentBusinessObject.name, currentBusinessObject.id)) {
                                return {
                                    valid: false,
                                    msg: `A business object class with name: "${currentBusinessObject.name}" already exists.`
                                }
                            }
                        }
                    }
                    return {valid: true, msg: undefined}
                };
            };
            this.init();
        }

        function attachAutoResizeDataGrid(grid, gridId) {
            const gridDomElm = $('#' + gridId);
            if (!gridDomElm || typeof gridDomElm.offset() === "undefined") {
                return null;
            }

            if ($(document.body).hasClass("mini-navbar")) {
                resizeToFitBrowserWindow(grid, gridId, true);
            } else {
                resizeToFitBrowserWindow(grid, gridId, false);
            }

            $("#hide-nav-btn").on("click", function () {
                if (!$(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });

            $(window).on("resize", function () {
                if ($(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
        }

        function calculateNewDimensions(minNavBarEnabled) {
            const $accordeon = $("#accordeon");
            if (minNavBarEnabled) {
                return {
                    height: $accordeon.height() - 54,
                    width: "100%"
                }
            }
            return {
                height: $accordeon.height() - 54,
                width: "100%"
            }
        }

        function resizeToFitBrowserWindow(grid, gridId, minNavBarEnabled) {
            const newSizes = calculateNewDimensions(minNavBarEnabled);

            $('#' + gridId).height(newSizes.height);

            if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && grid) {
                grid.resizeCanvas();
            }
        }

        function removeFilters() {
            columnFilters = {};
            let header = grid.getHeaderRow();
            $(header).children('div').each(function (index, element) {
                if (index !== 0) {
                    $(element).children().val("");
                }

            });
        }

        $(() => {
            const $businessObjectTypesGrid = $("#BusinessObjectTypesGrid");
            dataView = new Slick.Data.DataView();
            dataView.beginUpdate();
            dataView.setItems(data);
            dataView.setFilter(filter);
            dataView.endUpdate();

            if ($businessObjectTypesGrid[0]) {
                grid = new Slick.Grid("#BusinessObjectTypesGrid", dataView, columns, options);
                $businessObjectTypesGrid.data("gridInstance", grid);
                grid.registerPlugin(radioSelector);

                grid.onSort.subscribe(function (e, args) {
                    const currentBusinessObject = getCurrentBusinessObject();
                    if (currentBusinessObject) {
                        if (businessObjectsWrapper.hasBusinessObject(currentBusinessObject.id)) {
                            const businessObject = businessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                            if (!businessObject.equal(currentBusinessObject)) {
                                confirm(businessObject);
                            } else {
                                sort();
                            }
                        } else {
                            confirm();
                        }
                    } else {
                        sort()
                    }

                    function sort() {
                        const sortCol = args.sortCol;
                        dataView.sort(function (dataRow1, dataRow2) {
                            const field = sortCol.field;
                            const sign = args.sortAsc ? 1 : -1;

                            let value1 = dataRow1[field];
                            let value2 = dataRow2[field];
                            switch (field) {
                                case "instancesCount":
                                    return numberComparator(value1, value2, sign);
                                default:
                                    return stringComparator(value1, value2, sign);
                            }
                        });
                        grid.invalidate();
                        grid.render();
                    }

                    function confirm(businessObject?) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'There are unsaved changes. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        if (grid.getEditorLock().isActive()) {
                                            grid.getEditorLock().cancelCurrentEdit();
                                        }
                                        if (businessObject) {
                                            currentBusinessObject.name = businessObject.name;
                                            currentBusinessObject.description = businessObject.description;
                                            currentBusinessObject.systemRequired = businessObject.systemRequired;
                                        } else {
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            Utils.eventDispatcher(EVENTS.boView.setBusinessObject, {
                                                businessObject: null
                                            });
                                            dataView.endUpdate();
                                            grid.setSelectedRows([]);
                                            BusinessObject.enableButton("types-new-btn");
                                        }
                                        sort();
                                    }
                                },
                                cancel: function () {
                                    grid.setActiveCell(grid.getActiveCell().row, grid.getActiveCell().cell);
                                }
                            }
                        });
                    }
                });

                dataView.onRowCountChanged.subscribe(function () {
                    grid.updateRowCount();
                    grid.render();
                });

                dataView.onRowsChanged.subscribe(function (e, args) {
                    grid.invalidateRows(args.rows);
                    grid.render();
                });

                grid.onBeforeEditCell.subscribe(function (e, args) {
                    const currentBusinessObject = getCurrentBusinessObject();
                    const currentBusinessObjectsWrapper = getBusinessObjectWrapper();
                    const originalBusinessObject = currentBusinessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                    if (args.column.field !== "systemRequired" && (originalBusinessObject && originalBusinessObject.systemRequired)) {
                        toastr.warning("The Business Object Class you are trying to edit is required for the system. Please set System Required to false and save it to continue editing.");
                        return false;
                    }
                });

                Utils.$(grid.getHeaderRow()).unbind();
                Utils.$(grid.getHeaderRow()).delegate(":input", "keyup search", function () {
                    const columnId = $(this).data("columnId");
                    if (columnId != null) {
                        const currentBusinessObject = getCurrentBusinessObject();
                        const businessObjectWrapper = getBusinessObjectWrapper();
                        if (currentBusinessObject) {
                            if (businessObjectWrapper.hasBusinessObject(currentBusinessObject.id)) {
                                const businessObject = businessObjectWrapper.getBusinessObject(currentBusinessObject.id);
                                if (!businessObject.equal(currentBusinessObject)) {
                                    Utils.$.confirm({
                                        title: 'Confirm?',
                                        keyboardEnabled: true,
                                        escapeKey: 'cancel',
                                        backgroundDismiss: false,
                                        content: 'There are unsaved changes. Are you sure you want to continue?',
                                        type: 'red',
                                        theme: 'dark',
                                        typeAnimated: false,
                                        buttons: {
                                            ok: {
                                                text: "Yes!",
                                                btnClass: 'btn-danger',
                                                keys: ['enter'],
                                                action: () => {
                                                    if (grid.getEditorLock().isActive()) {
                                                        grid.getEditorLock().cancelCurrentEdit();
                                                    }

                                                    currentBusinessObject.name = businessObject.name;
                                                    currentBusinessObject.description = businessObject.description;
                                                    currentBusinessObject.systemRequired = businessObject.systemRequired;

                                                    columnFilters[columnId] = Utils.$.trim(Utils.$(this).val());
                                                    dataView.refresh();
                                                    grid.invalidate();
                                                    grid.render();
                                                }
                                            },
                                            cancel: function () {
                                            }
                                        }
                                    });
                                } else {
                                    columnFilters[columnId] = Utils.$.trim(Utils.$(this).val());
                                    dataView.refresh();
                                }
                            }
                        } else {
                            columnFilters[columnId] = $.trim(Utils.$(this).val());
                            dataView.refresh();
                        }
                    }
                });

                grid.onHeaderRowCellRendered.subscribe(function (e, args) {
                    $(args.node).empty();
                    if (args.column.id !== "type-grid-checkbox") {
                        $(`<input class=rounded type='search' placeholder="🔍">`)
                            .data("columnId", args.column.id)
                            .val(columnFilters[args.column.id])
                            .appendTo(args.node);
                    }
                });

                grid.onSelectedRowsChanged.subscribe((e) => {
                    const row = grid.getSelectedRows()[0];
                    const item = dataView.getItem(row);
                    if (item) {
                        Utils.eventDispatcher(EVENTS.boView.setBusinessObject, {
                            businessObject: item.clone()
                        });
                    } else {
                        Utils.eventDispatcher(EVENTS.boView.setBusinessObject, {
                            businessObject: null
                        });
                    }
                    BusinessObject.disableButton("types-save-btn");
                    Utils.$(".qtip").remove();
                    Utils.$('[data-hasqtip]').qtip('destroy', true);
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                });

                grid.onKeyDown.subscribe(function (event) {
                    if (grid.getActiveCell()) {
                        if (event.keyCode === 9 && event.shiftKey === false) {
                            if (grid.getActiveCell().cell === lastEditableCol) {
                                if (!$("#types-save-btn").prop("disabled")) {
                                    saveBoClass(true);
                                } else {
                                    grid.gotoCell(grid.getActiveCell().row, firstEditableCol, true);
                                }
                                event.stopImmediatePropagation();
                            }
                        }
                        if (event.keyCode === 9 && event.shiftKey === true) {
                            if (grid.getActiveCell().cell === firstEditableCol) {
                                grid.gotoCell(grid.getActiveCell().row, lastEditableCol, true);
                                event.stopImmediatePropagation();
                            }
                        }
                    }
                    if (event.keyCode === 13) {
                        grid.getEditController().commitCurrentEdit();
                        event.stopImmediatePropagation();
                    }
                });

                grid.onClick.subscribe(function (e, args) {
                    if (grid.getEditorLock().isActive()) {
                        grid.getEditorLock().commitCurrentEdit();
                    }
                    if (grid.getSelectedRows()[0] !== args.row) {
                        grid.setSelectedRows([args.row]);
                    }
                });

                grid.onValidationError.subscribe(function (e, args) {
                    /**
                     * @namespace toastr.warning
                     */
                    toastr.warning(args.validationResults.msg);
                });

                grid.onDblClick.subscribe(function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                });
                grid.onBeforeRowChange = (e, args) => {
                    const {currentBusinessObject} = this.props;
                    if (currentBusinessObject) {
                        if (businessObjectsWrapper.hasBusinessObject(currentBusinessObject.id)) {
                            const businessObject = businessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                            if (!businessObject.equal(currentBusinessObject)) {
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'There are unsaved changes. Are you sure you want to continue?',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                if (grid.getEditorLock().isActive()) {
                                                    grid.getEditorLock().cancelCurrentEdit();
                                                }
                                                currentBusinessObject.name = businessObject.name;
                                                currentBusinessObject.description = businessObject.description;
                                                currentBusinessObject.systemRequired = businessObject.systemRequired;
                                                dataView.beginUpdate();
                                                dataView.updateItem(currentBusinessObject.id, currentBusinessObject.clone());
                                                dataView.endUpdate();
                                                grid.setSelectedRows([args.row]);
                                                grid.setActiveCell(args.row, args.cell);
                                            }
                                        },
                                        cancel: function () {

                                        }
                                    }
                                });
                                e.preventDefault();
                                e.stopImmediatePropagation();
                            }
                        } else {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Are you sure you want to continue?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            dataView.endUpdate();
                                            grid.setSelectedRows([args.row - 1]);
                                            grid.setActiveCell(args.row - 1, args.cell);
                                            BusinessObject.enableButton("types-new-btn");
                                        }
                                    },
                                    cancel: function () {

                                    }
                                }
                            });
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    }
                };

                $("#types-new-btn")
                    .unbind()
                    .click(function () {
                        removeFilters();
                        const currentBusinessObject = getCurrentBusinessObject();
                        if (currentBusinessObject) {
                            if (businessObjectsWrapper.hasBusinessObject(currentBusinessObject.id)) {
                                const businessObject = businessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                                if (businessObject.id === -1) {
                                    toastr.warning("Blank row already exists");
                                    return;
                                }
                                if (!businessObject.equal(currentBusinessObject)) {
                                    Utils.$.confirm({
                                        title: 'Confirm?',
                                        keyboardEnabled: true,
                                        escapeKey: 'cancel',
                                        backgroundDismiss: false,
                                        content: 'There are unsaved changes. Are you sure you want to continue?',
                                        type: 'red',
                                        theme: 'dark',
                                        typeAnimated: false,
                                        buttons: {
                                            ok: {
                                                text: "Yes!",
                                                btnClass: 'btn-danger',
                                                keys: ['enter'],
                                                action: () => {
                                                    if (grid.getEditorLock().isActive()) {
                                                        grid.getEditorLock().cancelCurrentEdit();
                                                    }
                                                    currentBusinessObject.name = businessObject.name;
                                                    currentBusinessObject.description = businessObject.description;
                                                    currentBusinessObject.systemRequired = businessObject.systemRequired;
                                                    const row = grid.getSelectedRows()[0];
                                                    if (row != null) {
                                                        dataView.beginUpdate();
                                                        dataView.updateItem(businessObject.id, businessObject.clone());
                                                        dataView.endUpdate();
                                                    }
                                                    BusinessObject.disableButton("types-save-btn", "");
                                                    removeFilters()
                                                    newRow();
                                                }
                                            },
                                            cancel: function () {
                                            }
                                        }
                                    });
                                } else {
                                    newRow();
                                }
                            }
                        } else {
                            newRow();
                        }

                        function newRow() {
                            addNewRow(dataView);
                            grid.setSelectedRows([0]);
                            grid.setActiveCell(0, 1);
                        }
                    });

                Utils.$("#types-save-btn")
                    .unbind()
                    .click(function () {
                        if (!$("#types-save-btn").prop("disabled")) {
                            saveBoClass(false);
                        }
                    });

                Utils.$("#types-delete-btn")
                    .unbind()
                    .click(() => {
                        const row = grid.getSelectedRows()[0];
                        const item = dataView.getItem(row);
                        if (item) {
                            const currentBusinessObject = getCurrentBusinessObject();
                            if (businessObjectsWrapper.hasBusinessObject(currentBusinessObject.id)) {
                                const businessObject = businessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                                const isErasable = businessObject.isErasable();
                                if (!isErasable.erasable) {
                                    toastr.warning(isErasable.msg);
                                    return
                                }
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'You are about to delete one business object class, this procedure is irreversible. Are you sure you want to continue?',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                this.props.deleteBusinessObject(businessObject.id, {event: EVENTS.boView.typesGrid.delete});
                                                this.props.setBusinessObject(null);
                                            }
                                        },
                                        cancel: function () {
                                        }
                                    }
                                });
                            } else {
                                const row = dataView.getRowById(currentBusinessObject.id);
                                dataView.beginUpdate();
                                dataView.deleteItem(currentBusinessObject.id);
                                dataView.endUpdate();
                                grid.invalidateRow(row);
                                grid.setSelectedRows([row]);
                                grid.render();
                                BusinessObject.enableButton("types-new-btn");
                            }
                        }
                    });

                new Slick.Controls.ColumnPicker(columns, grid, options);
                grid.setSelectionModel(new Slick.RowSelectionModel({selectActiveRow: false}));
                dataView.syncGridSelection(grid, true, false);
                grid.init();
                if (dataView.getLength() === 0) {
                    addNewRow(dataView);
                }
                attachAutoResizeDataGrid(grid, "BusinessObjectTypesGrid");
                BusinessObject.enableButton("types-new-btn");
            }
        });
        const saveBoClass = (withNewRow) => {
            let rows = grid.getSelectedRows();
            if (rows.length === 0) {
                return;
            }
            const {currentBusinessObject} = this.props;
            const businessObjectWrapper = getBusinessObjectWrapper();
            const result = businessObjectWrapper.checkBusinessObjectsBeforeSave(currentBusinessObject);
            if (result.valid) {
                if (grid.getEditorLock().isActive()) {
                    grid.getEditorLock().commitCurrentEdit();
                }
                if (currentBusinessObject.id === -1) {
                    const dto = {
                        name: currentBusinessObject.name,
                        description: currentBusinessObject.description,
                        systemRequired: currentBusinessObject.systemRequired
                    };
                    this.props.createBusinessObject(dto, {
                        event: EVENTS.boView.typesGrid.create,
                        withNewRow
                    }, currentBusinessObject.uniqueName ? {uniqueName: currentBusinessObject.uniqueName} : null);
                } else {
                    const businessObject = businessObjectsWrapper.getBusinessObject(currentBusinessObject.id);
                    const uniqueNameFlagChanged = currentBusinessObject.uniqueName !== businessObject.uniqueName;
                    const baseDataChanged = currentBusinessObject.name !== businessObject.name ||
                        currentBusinessObject.description !== businessObject.description ||
                        currentBusinessObject.systemRequired !== businessObject.systemRequired;

                    if (baseDataChanged) {
                        const dto = {
                            id: currentBusinessObject.id,
                            name: currentBusinessObject.name,
                            description: currentBusinessObject.description,
                            systemRequired: currentBusinessObject.systemRequired
                        };
                        this.props.updateBusinessObject(dto.id, {
                            boClass: dto,
                            event: EVENTS.boView.typesGrid.update
                        }, uniqueNameFlagChanged ? currentBusinessObject.clone() : null);
                    } else if (uniqueNameFlagChanged) {
                        this.props.updateBOUniqueNameAttribute(currentBusinessObject.id, currentBusinessObject.uniqueName,
                            {
                                boClass: currentBusinessObject,
                                event: EVENTS.boView.typesGrid.update,
                                showSuccessMessage: true
                            });
                    }
                }
            } else {
                BusinessObject.disableButton("types-save-btn");
                BusinessObjects.appendQtipsToNode(result.data, grid, $("#types-save-btn"));
            }
        };

    };

    render() {
        const {currentBusinessObject} = this.props;
        return (
            <div>
                <div className="bo-core-header background-gradient" style={{marginBottom: 5, paddingTop: 5}}>
                    <label style={
                        {
                            marginLeft: 2,
                            float: "left",
                            color: "#FFFFFF",
                            paddingTop: 7,
                            fontSize: 18,
                            width: "calc(100% - 190px)",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        }
                    }
                           title={`Type: ${currentBusinessObject ? currentBusinessObject.name : ""}`}
                    >
                        {`Type: ${currentBusinessObject ? currentBusinessObject.name : ""}`}
                    </label>
                    <div style={{width: 185, float: "right"}}>
                        <button style={{marginRight: 2, height: 36}} id="types-new-btn"
                                className="btn btn-success">New
                        </button>
                        <button style={{marginRight: 2, height: 36}} disabled id="types-save-btn"
                                className="btn btn-primary">Save
                        </button>
                        <button style={{marginRight: 2}} id="types-delete-btn"
                                className="btn btn-danger">Delete
                        </button>
                    </div>
                </div>
                <div className="custom-header" style={{border: "0px", backgroundColor: "#FFFFFF"}}
                     id="BusinessObjectTypesGrid"/>
            </div>
        )
    }
}

function addNewRow(dataView) {
    dataView.beginUpdate();
    dataView.insertItem(0, new BusinessObject(-1, "", "n/a", 0, [],
        [], [], false, false, false));
    dataView.endUpdate();
    BusinessObject.disableButton("types-new-btn");
}


const mapStateToProps = (state, ownProps) => {
    return {
        currentBusinessObject: ownProps.currentBusinessObject,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createBusinessObject: (businessObject, event, uniqueNameObj?) => {
            dispatch(createBusinessObject(businessObject, event, uniqueNameObj))
        },
        updateBusinessObject: (id, args, uniqueNameObj?) => {
            dispatch(updateBusinessObject(id, args, uniqueNameObj))
        },
        deleteBusinessObject: (id, args) => {
            dispatch(deleteBusinessObject(id, args))
        },
        updateBOUniqueNameAttribute: (id, isUnique, args) => {
            dispatch(updateBOUniqueNameAttribute(id, isUnique, args))
        },
        setBusinessObject: (obj) => {
            dispatch(setBusinessObject(obj))
        },
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjectTypesGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/BusinessObjectTypesGrid.tsx